import apiService from "./ApiService"

class PendenciaService {

  async listar() {
    try {
      return await apiService.get('pendencia')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
}

const pendenciaService = new PendenciaService()
export default pendenciaService
